// =============================================================================
// features/configuracoes/comercial/SaveBar.tsx — Barra fixa de "alterações
// não salvas" para os grupos ligados a `sales_settings` (PATCH único).
// =============================================================================

import * as React from 'react';

import { Button } from '../../../components/ui/Button';

interface SaveBarProps {
  isPending: boolean;
  hasErrors: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

export function SaveBar({
  isPending,
  hasErrors,
  onDiscard,
  onSave,
}: SaveBarProps): React.JSX.Element {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 flex items-center justify-between gap-4 px-6 py-4 z-40"
      style={{
        background: 'var(--bg-elev-1)',
        boxShadow: 'var(--elev-5)',
        borderTop: '1px solid var(--border)',
      }}
    >
      <span className="font-sans text-ink-3" style={{ fontSize: 'var(--text-sm)' }}>
        Você tem alterações não salvas.
      </span>
      <div className="flex gap-3">
        <Button variant="ghost" onClick={onDiscard} disabled={isPending}>
          Descartar
        </Button>
        <Button variant="primary" onClick={onSave} disabled={isPending || hasErrors}>
          {isPending ? 'Salvando…' : 'Salvar alterações'}
        </Button>
      </div>
    </div>
  );
}
